(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-slider')) {
    customElements.define(
      'video-slider',
      class VideoSlider extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('.video-slider__slide[data-index]'));
          this.dots = Array.from(this.querySelectorAll('.video-slider__dot'));
          this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
          this.timer = null;
          this.startX = 0;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.querySelector('.video-slider__arrow--previous')?.addEventListener('click', () => this.show(this.current - 1));
          this.querySelector('.video-slider__arrow--next')?.addEventListener('click', () => this.show(this.current + 1));
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.index))));

          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          this.addEventListener('touchstart', (event) => {
            this.startX = event.touches[0].clientX;
          }, { passive: true });
          this.addEventListener('touchend', (event) => {
            const distance = event.changedTouches[0].clientX - this.startX;
            if (Math.abs(distance) > 50) this.show(this.current + (distance < 0 ? 1 : -1));
          }, { passive: true });

          this.loadPlayer(this.slides[this.current]);
          this.play(this.slides[this.current]);
          this.start();

          if (Shopify.designMode) {
            this.addEventListener('shopify:block:select', (event) => {
              const index = this.slides.indexOf(event.target);
              if (index >= 0) this.show(index);
            });
          }
        }

        disconnectedCallback() {
          this.stop();
        }

        videoId(url) {
          if (!url) return '';
          const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?.*v=|embed\/|shorts\/))([A-Za-z0-9_-]{11})/);
          return match ? match[1] : '';
        }

        loadPlayer(slide) {
          if (!slide || slide.dataset.loaded === 'true') return;
          const id = this.videoId(slide.dataset.videoUrl);
          if (!id) return;
          const player = slide.querySelector('.video-slider__player');
          const iframe = document.createElement('iframe');
          iframe.title = 'Background video';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.setAttribute('allowfullscreen', '');
          iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&controls=0&loop=1&playlist=${id}&playsinline=1&rel=0&modestbranding=1&enablejsapi=1`;
          player.appendChild(iframe);
          slide.dataset.loaded = 'true';
        }

        command(slide, command) {
          const iframe = slide?.querySelector('iframe');
          if (!iframe?.contentWindow) return;
          iframe.contentWindow.postMessage(JSON.stringify({
            event: 'command',
            func: command,
            args: []
          }), '*');
        }

        play(slide) {
          this.loadPlayer(slide);
          window.setTimeout(() => this.command(slide, 'playVideo'), 150);
        }

        show(index) {
          if (!this.slides.length) return;
          const next = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === next;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
            if (!active) this.command(slide, 'pauseVideo');
          });
          this.dots.forEach((dot, dotIndex) => {
            const active = dotIndex === next;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          this.current = next;
          this.play(this.slides[next]);
          this.start();
        }

        start() {
          this.stop();
          if (this.dataset.autoplay !== 'true' || this.reduceMotion || this.slides.length < 2) return;
          this.timer = window.setInterval(() => this.show(this.current + 1), Number(this.dataset.delay));
        }

        stop() {
          if (this.timer) window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
